import { toast } from "sonner";
import { nextStep } from "@/lib/nextStep";

// HIS RULE (30 Oct): a RED refusal stays on screen until the person taps it away. A YELLOW warning stays too —
// until it is tapped OR the person does their next scan or action, so it is never missed and never slows the
// floor down. Successes still fade. One place for the whole app: every toast.error / toast.warning comes here.
const baseError = toast.error;
const baseWarning = toast.warning;
const openWarnings = new Map();   // toast id -> when it was raised
const clearers = new Set();
const FRESH_MS = 300;             // a warning raised by THIS action is not cleared by it
let lastScan = { text: "", at: 0 };

const KEEP = { duration: Infinity, closeButton: true, dismissible: true };
const okButton = { label: "OK", onClick: () => {} };

// the scan card already says it in big words — the same sentence is not stacked again as a toast
export function noteScanAnswer(text) { lastScan = { text: String(text || ""), at: Date.now() }; }
const echoesScan = (m) => typeof m === "string" && !!m && m === lastScan.text && Date.now() - lastScan.at < 2500;

export { nextStep } from "@/lib/nextStep";

toast.error = (message, opts = {}) => {
  if (echoesScan(message)) return undefined;
  const step = opts.description ? null : nextStep(message);
  return baseError(message, { cancel: okButton, ...(step ? { description: step } : {}), ...opts, ...KEEP });
};

toast.warning = (message, opts = {}) => {
  if (echoesScan(message)) return undefined;
  const id = baseWarning(message, { cancel: okButton, ...opts, ...KEEP,
    onDismiss: (t) => { openWarnings.delete(t.id); opts.onDismiss?.(t); } });
  openWarnings.set(id, Date.now());
  return id;
};

export function onNextAction(fn) { clearers.add(fn); return () => clearers.delete(fn); }

export function clearWarnings() {
  const now = Date.now();
  for (const [id, at] of openWarnings) {
    if (now - at >= FRESH_MS) { toast.dismiss(id); openWarnings.delete(id); }
  }
  clearers.forEach((fn) => fn(now));
}

function nextAction(e) {
  if (e.type === "keydown" && e.key !== "Enter") return;
  if (e.target?.closest?.("[data-sonner-toaster],[data-refusal-card]")) return;
  clearWarnings();
}

if (typeof document !== "undefined") {
  // CAPTURE phase: runs before the tap's own handler, so a warning that tap raises is never cleared by it
  document.addEventListener("click", nextAction, true);
  document.addEventListener("keydown", nextAction, true);
}

export const REFUSAL_FRESH_MS = FRESH_MS;
